/**
 * firebaseUtils.js
 * Shared Firebase helpers usable by any module.
 * Uses getApp() so Firebase must be initialized by App.js first.
 */
import { getApp } from 'firebase/app';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';

let _db = null;
const getDB = () => {
  if (!_db) { try { _db = getFirestore(getApp()); } catch (_) {} }
  return _db;
};

/** Browser SubtleCrypto SHA-256 */
export async function sha256(str) {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(str));
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
}

/** Write an entry to the access_logs Firestore collection */
export async function writeLog(action, details = {}) {
  const db = getDB();
  if (!db) return;
  try {
    await addDoc(collection(db, 'access_logs'), {
      action, ...details, timestamp: serverTimestamp(),
    });
  } catch (_) {}
}
